// PRD-47 v2 — campus-level generation audience.
//
// Mirrors the backend, which is canonical (magic-values.md §1):
//   • `core.models.EducationLevel` — apps/backend/core/models.py
//
// The string values ARE the wire contract; the UI maps each to an es-MX /
// en-US label via `schools:education_level.*`.

export const EDUCATION_LEVELS = ["highschool", "university"] as const
export type EducationLevel = (typeof EDUCATION_LEVELS)[number]

// Backend column default — what an omitted value resolves to.
export const DEFAULT_EDUCATION_LEVEL: EducationLevel = "highschool"
